import React, {useEffect, useState} from "react";
import opencage from "opencage-api-client";
import localWeather from "../../../images/localWeather.png";
import Loader from "./Loader";
import {useTranslation} from "react-i18next";
import {requestCurrentPosition} from "../../../utils/geolocation";
import {getDateLocale} from "../../../utils/date";

const FALLBACK_LOCATION = {
  latitude: 48.7872,
  longitude: 2.3928,
  postcode: "94400",
  state: "Vitry-sur-Seine",
};

const Weather = ({setCurrentPostCode}) => {
  const [weatherData, setWeatherData] = useState(null);
  const [locationData, setLocationData] = useState(null);
  const [error, setError] = useState(null);
  const {t} = useTranslation();

  useEffect(() => {
    // Fetch weather data based on location
    const fetchWeather = async (latitude, longitude) => {
      try {
        setError(null);
        const apiKey = "cf2c181635f37c9edb166256ce0fa50c"; // Replace with your weather API key
        const response = await fetch(
          `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&units=metric&appid=${apiKey}`,
        );
        if (!response.ok) {
          throw new Error("Failed to fetch weather data");
        }
        const data = await response.json();

        setWeatherData(data);
      } catch (error) {
        setError("WeatherUnavailable");
      }
    };

    const fetchFallbackWeather = () => {
      setLocationData({
        postcode: FALLBACK_LOCATION.postcode,
        state: FALLBACK_LOCATION.state,
      });
      fetchWeather(FALLBACK_LOCATION.latitude, FALLBACK_LOCATION.longitude);
    };

    // Get user location
    const getLocation = () => {
      requestCurrentPosition()
        .then((position) => {
            const {latitude, longitude} = position.coords;
            try {
              opencage
                .geocode({
                  q: `${latitude}, ${longitude}`,
                  language: "fr",
                  key: "888525df3d524cc29249eed41d4b5368",
                })
                .then((data) => {
                  // { "components": { "house_number": "1330", "road": "Middle Avenue", "postcode": "94025", "town": ...
                  if (data.status.code === 200 && data.results.length > 0) {
                    setLocationData(data.results[0].components);
                    if (!!setCurrentPostCode) {
                      setCurrentPostCode(
                        data?.results[0]?.components?.postcode,
                      );
                    }
                    // "1330 Middle Avenue, Menlo Park, Californie 94025, États-Unis d'Amérique"
                  }
                })
                .catch(() => {
                  setLocationData({state: "Position actuelle"});
                });
            } catch (error) {
              // Error handling: weather data fetch failed
            }
            fetchWeather(latitude, longitude);
        })
        .catch(() => fetchFallbackWeather());
    };

    getLocation();
  }, [setCurrentPostCode]);

  return (
    <div className="flex w-full flex-col justify-start rounded-2xl  bg-white  text-[#19295C] font-bold text-xl">
      {error ? (
        <div className="text-red-500 p-4  font-medium text-xs">{t(error)}</div>
      ) : weatherData ? (
        <>
          <div className="flex justify-start items-start gap-3 p-3  font-semibold text-sm border-b border-solid border-[#D6E2EF] ">
            <img src={localWeather} alt="local" className="w-5 h-5" />

            {`${locationData?.postcode} - ${locationData?.state} `}
          </div>
          <div className="flex justify-start items-center gap-2 p-2  font-semibold text-sm flex-wrap  ">
            <img
              src={`https://openweathermap.org/img/wn/${weatherData.weather[0].icon}@2x.png`}
              alt={weatherData.weather[0].description}
              className="w-14 "
            />
            <div className="flex justify-start items-center flex-col">
              <span className="text-sm font-semibold text-[#3D4465] ">
                {t("filterToday")}
              </span>
              <span className="text-xs font-normal text-[#7e7e7e] ">
                {new Date().toLocaleDateString(getDateLocale(), {
                  // weekday: "short",
                  // jour de la semaine
                  year: "numeric", // année
                  month: "long", // mois en toutes lettres
                  day: "numeric", // jour du mois
                })}
              </span>
            </div>
            <div className="flex items-center justify-center flex-grow gap-5">
              <span className="font-semibold text-[20px] text-[#3D4465] ">
                {Math.round(weatherData.main.temp_max)}°
              </span>
              <span className="font-semibold text-[16px] text-[#7e7e7e] ">
                {Math.round(weatherData.main.temp_min)}°
              </span>
            </div>
          </div>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default Weather;
